import InboundFieldGrid from './inboundFieldGrid.view';

export default InboundFieldGrid;
